import React, { useEffect, useState } from 'react';
import AppDownloadHero from '../../components/AppDownloadHero';

/** Matches web path /app; native app should handle this scheme path. */
const OPEN_APP_DEEP_LINK = 'vitalstaf://app';

const isIOSDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isAndroidDevice = () => /Android/i.test(navigator.userAgent);

const AppOpenLanding = () => {
  const [showContent, setShowContent] = useState(false);
  const isMobile = isIOSDevice() || isAndroidDevice();

  useEffect(() => {
    if (!isMobile) {
      setShowContent(true);
      return;
    }

    let timeoutId;
    let isMounted = true;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearTimeout(timeoutId);
        if (isMounted) setShowContent(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.location.href = OPEN_APP_DEEP_LINK;

    timeoutId = setTimeout(() => {
      if (isMounted) setShowContent(true);
    }, 3000);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isMobile]);

  const openApp = () => {
    window.location.href = OPEN_APP_DEEP_LINK;
  };

  if (isMobile && !showContent) {
    return <AppDownloadHero loading loadingText="Opening the VitalStaf app…" />;
  }

  return (
    <AppDownloadHero
      title="Get the VitalStaf app"
      subtitle={
        isMobile
          ? 'If the app did not open, download it below to browse jobs, apply, and pick up shifts.'
          : 'Download VitalStaf for iOS or Android to browse jobs, apply in minutes, and get matched to shifts.'
      }
      hint={isMobile ? 'No app yet? Use the store links below.' : 'Available on iPhone, iPad, and Android.'}
      showOpenInApp={isMobile}
      onOpenInApp={openApp}
    />
  );
};

export default AppOpenLanding;
